module.exports = __webpack_public_path__ + "static/media/aukey-latitude-ep-b40.de84a4ff.jpg";